import { GlobalAxios } from "../axios/axios-config";
import { IInternalProcedure } from "../models/internal-procedure";

const INTERNAL_PROCEDURE_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/InternalProcedure/InternalProcedure";

export const internalProcedureList = (params?: any) => {
  return GlobalAxios.get<IInternalProcedure[]>(INTERNAL_PROCEDURE_ROUTE, {
    params: params,
    paramsSerializer: {
      indexes: null,
    },
  });
};
